// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutScheduleDialog-Form_cls1__ueAr8","cls2":"PayoutScheduleDialog-Form_cls2__ZPbqD PayoutScheduleDialog-Form_cls1__ueAr8"};